import { observer } from 'mobx-react-lite'
import { type FC } from 'react'
import { Icon, Typography } from 'shared/ui'
import { uiStore } from 'shared/store/uiStore'
import { parseMeet } from 'entities/Message/lib/parseMeet'
import { MessageCardType, type MessageProps } from 'widgets/MessageCard/ui/types'
import { ConversationMessageCardItem } from 'widgets/MessageCard/ui/ConversationMessageCardItem/ConversationMessageCardItem'
import { DateContent } from 'widgets/MessageCard/ui/DateContent/DateContent'
import { BodyRawContent } from 'widgets/MessageCard/ui/BodyRawContent/BodyRawContent'
import styles from './styles.module.scss'

type ITextMeetContentProps = MessageProps

export const TextMeetContent: FC<ITextMeetContentProps> = observer((props) => {
  const { body } = props.message
  const noBody = !body

  if (noBody) return null

  const parseBody = parseMeet(body)

  const content = () => {
    if (typeof parseBody === 'object') {
      const title = parseBody.event_name
      const fromDate = uiStore.dayjs(parseBody.start_date).format('dddd, MMMM Do h:mm A')
      const toDate = uiStore.dayjs(parseBody.end_date).format('h:mm A')
      const description = `${fromDate} - ${toDate}`

      return (
        <div className={styles.card}>
          <div className={styles.card__avatar}>
            <Icon icon={'calendar'} fontSize={20} color={'var(--content-primary-tertiary)'} />
          </div>
          <div className={styles.card__content}>
            <Typography
              ariaLabel={'Meet_Title'}
              variant={'body-rg-medium'}
              tag={'div'}
              className={styles.card__title}
            >
              {title}
            </Typography>
            <Typography
              ariaLabel={'Meet_Desc'}
              variant={'body-xs-regular'}
              tag={'div'}
              className={styles.card__desc}
            >
              {description}
            </Typography>
          </div>
        </div>
      )
    }

    return <BodyRawContent message={props.message} selectedSearch={''} />
  }

  return (
    <ConversationMessageCardItem
      className={styles.withPreviews}
      message={props.message}
      type={MessageCardType.Text}
    >
      {content()}
      <DateContent {...props} hideStatus />
    </ConversationMessageCardItem>
  )
})
